import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: ArchivedFieldbookCreateInput!
  ) {
    createOneArchivedFieldbook(data: $data) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Caderno de campo arquivado`, mutationTypes.CREATE)
)
